const state = () => ({
	ruleForm: {
		writer_name: '', 
		title: '',
		cover_image: new Object(),
		description: '',
		tag: [],
	},
	iconPlus: 'el-icon-plus',
	iconCheck: 'el-icon-check',
	tagArray: [{
			id: 1,
			name: 'Romance',
			select: false,
			disabled: false
		},
		{
			id: 2,
			name: 'LGBT',
			select: false,
			disabled: false
		},
		{
			id: 3,
			name: 'Action',
			select: false,
			disabled: false
		},
		{
			id: 4,
			name: 'Youth',
			select: false,
			disabled: false
		},
		{
			id: 5,
			name: 'Adventure',
			select: false,
			disabled: false
		},
		{
			id: 6,
			name: 'Drama',
			select: false,
			disabled: false
		},
		{
			id: 7,
			name: 'Comedy',
			select: false,
			disabled: false
		},
		{
			id: 8,
			name: 'Horror',
			select: false,
			disabled: false
		},
		{
			id: 9,
			name: 'Fantasy',
			select: false,
			disabled: false
		},
		{
			id: 10,
			name: '18+',
			select: false,
			disabled: false
		},
		{
			id: 11,
			name: 'Suspense',
			select: false,
			disabled: false
		},
		{
			id: 12,
			name: 'Others',
			select: false,
			disabled: false
		}
	],
	rules: {
		writer_name: [{
				required: true,
				message: 'Input your name.',
				trigger: 'blur'
			},
			{
				min: 3,
				max: 20,
				message: 'Please enter at least three characters.',
				trigger: 'blur'
			}
		],
		title: [{
				required: true,
				message: 'Enter the title of the book.',
				trigger: 'blur'
			},
			{
				min: 3,
				max: 20,
				message: 'Please enter at least three characters.',
				trigger: 'blur'
			}
		],
		description: [{
				required: true,
				message: 'Description of the story.',
				trigger: 'blur'
			},
			{
				min: 3,
				max: 150,
				message: 'Please enter at least three characters.',
				trigger: 'blur'
			}
		],
		tag: [{
			required: true,
			message: 'Choose 1-3 categories to continue.'
		}]
	}	
})

// getters
const getters = {
	
}

// actions
const actions = {

}

// mutations
const mutations = {
	initTags(state) {
		state.tagArray.forEach(item => {
			item.select = false
			item.disabled = false
		})
		state.ruleForm = {
			writer_name: '',
			title: '',
			description: '',
			cover_image: new Object(),
			tag: [],
		}
	},
	setFromRouter(state, router) {
		state.ruleForm.book_id = router.book_id
	    state.ruleForm.writer_name = router.writer_name;
		state.ruleForm.title = router.title; 
		state.ruleForm.description = router.description;
		state.ruleForm.tag = JSON.parse('[' + String(router.tag) + ']')
		state.ruleForm.cover_image = router.cover_image 
		// 查找 包含categoriesGroup 添加，默认的选中状态
		const selectArray = state.tagArray.filter(item => { 
			return state.ruleForm.tag.indexOf(item.id) !== -1
		})
		selectArray.forEach(item => item.select = true)
		// 查找 不包含categoriesGroup  如果长度等于3 
		if (router.tag.length === 3) {
			const unSelectArray = state.tagArray.filter(item => {return state.ruleForm.tag.indexOf(item.id) === -1})
			unSelectArray.forEach(item => item.disabled = true)
		}
	},
	checkoutTag(state, tag) {
		tag.select = !tag.select
		// 如果选中的tag 有三个或者超过三个 则设置 除这三个之外的tags为不可点击的状态
		if (state.ruleForm.tag.length >= 3) {
			const unSelectArray = state.tagArray.filter(item => {return state.ruleForm.tag.indexOf(item.id) === -1})
			unSelectArray.forEach(item => item.disabled = true)
		} else {
			//设置所有为可点击状态
			state.tagArray.forEach(item => item.disabled = false)
		}
	}
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}